"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.countries = exports.langs = exports.locales = void 0;
var ja_1 = __importDefault(require("./locales/ja"));
var en_1 = __importDefault(require("./locales/en"));
var ko_1 = __importDefault(require("./locales/ko"));
exports.locales = { ja: ja_1.default, en: en_1.default, ko: ko_1.default };
exports.langs = Object.keys(exports.locales);
exports.countries = {
    ja: "jp",
    en: "us",
    ko: "kr",
};
